import { render } from "./Navbar.vue?vue&type=template&id=b5baeb86&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=b5baeb86&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b5baeb86"

export default script